import { render, staticRenderFns } from "./badmintonCourtDialog.vue?vue&type=template&id=b8c7ff82&"
import script from "./badmintonCourtDialog.vue?vue&type=script&lang=js&"
export * from "./badmintonCourtDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports